import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Error from './pages/error';
import Exhibitionexhibitorspage from './pages/ExhibitionExhibitors';
import Bookingpage from './pages/Booking';
import Gallery from './pages/Gallery';
import About from './pages/about';
const Paths = () => {
    return ( <>
    <BrowserRouter>
                <Routes>
                <Route path='/'  element={<Home />} /> 
                <Route path='*'  element={<Error />} />      
                <Route path='/Exhibition-Exhibitors'  element={ <Exhibitionexhibitorspage /> } />                   
                <Route path='/booking'  element={ <Bookingpage />} />
                 <Route path='/gallery'  element={  <Gallery />  } />      
                 <Route path='/about'  element={   <About />  } />                       
                </Routes>
    </BrowserRouter>
    </>  );
}
 
export default Paths;